<ng-container *ngIf="!!get">
    <tt-tabs [(ttSelectedId)]="get.bg_main">
        <tt-tab ttId="LIST" ttLabel="bg_accountingprocessing_main_list"></tt-tab>
        <tt-tab
            *ngIf="get.accountingfunction !== 'all'"
            ttId="SHOW"
            [ttLabel]="get.bg_main === 'LIST' ? 'bg_accountingprocessing_main_show' : 'accountingprocessing_show_' + get.accountingfunction"
        ></tt-tab>
    </tt-tabs>

    <div class="tt-accounting-processing__list-tab" [hidden]="get.bg_main !== 'LIST'">
        <tt-card>
            <tt-select ttLabel="businessco" [(ttModel)]="get.businessco_no" (ttModelChange)="onBusinessCoChanged()" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        </tt-card>
        <tt-tabs ttRememberId="w_accountingprocessing.accountingfunction" [(ttSelectedId)]="get.accountingfunction" ttAutoSelectFirst="false">
            <tt-tab
                *ngFor="let function of accountingFunctions"
                [ttId]="function.accountingfunction_id"
                [ttLabel]="function.accountingfunction_name"
                ttTranslateLabel="false"
                (ttClick)="get.custact_no_active = '0'"
            ></tt-tab>
            <tt-tab ttId="all" ttLabel="all" (ttClick)="get.custact_no_active = '0'"></tt-tab>
        </tt-tabs>
        <div class="tt-accounting-processing__list-tab" [hidden]="get.accountingfunction === 'all'">
            <tt-card>
                <tt-input ttRememberId="w_accountingprocessing.searchtext" ttLabel="searchtext" [(ttModel)]="get.searchtext" ttShowClearButton></tt-input>
                <tt-button-goto
                    *ngIf="get.accountingfunction === 'send'"
                    ttText="accountingprocessing_import_vouchers"
                    ttGoto="documents"
                    [ttGotoParms]="{ argtype: 'voucherimport', argvalue: '0' }"
                ></tt-button-goto>
            </tt-card>
            <tt-accounting-processing-list
                [accountingFunction]="get.accountingfunction"
                [businessCoNo]="get.businessco_no"
                [custactNo]="get.custact_no"
                [searchText]="get.searchtext"
            ></tt-accounting-processing-list>
        </div>
        <tt-grid [hidden]="get.accountingfunction !== 'all'" *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
        <tt-card>
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>
    <div class="tt-accounting-processing__show-tab" [hidden]="get.bg_main !== 'SHOW'">
        <tt-divider>
            <tt-divider-rows>
                <tt-divider-pane>
                    <tt-divider-columns>
                        <tt-divider-pane>
                            <tt-accounting-processing-carousel></tt-accounting-processing-carousel>
                        </tt-divider-pane>
                        <tt-divider-pane>
                            <tt-accounting-processing-head></tt-accounting-processing-head>
                        </tt-divider-pane>
                    </tt-divider-columns>
                </tt-divider-pane>
                <tt-divider-pane>
                    <!-- <tt-grid></tt-grid> -->
                </tt-divider-pane>
            </tt-divider-rows>
        </tt-divider>
    </div>
</ng-container>
